<template>
  <div id="app" class="app">
    <CommonHeader />
    <router-view></router-view>
    <CommonFooter />
    <ReturnTop v-if="!isMobile" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import utils from './util/WXshare.js'

import CommonHeader from './components/layout/header/Header.vue'
import CommonFooter from './components/layout/footer/Footer.vue'
import ReturnTop from './components/common/ReturnTop'

export default {
  name: 'app',
  provide () {
    return {
      newTime: this.newTime()
    }
  },
  components: {
    CommonHeader,
    CommonFooter,
    ReturnTop
  },
  computed: {
    ...mapState(['isMobile'])
  },
  created () {
    this.getLoginUser()
    this.setMoblie(this.checkMobile())
    this.initWxConfig()
  },
  mounted () {
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    ...mapMutations({
      setMoblie: 'CHECK_MOBILE'
    }),
    ...mapActions(['getLoginUser']),

    resizeHandler () {
      this.setMoblie(this.checkMobile())
    },

    checkMobile () {
      const ua = navigator.userAgent.toLowerCase()

      return /iphone|android|ucweb|ucbrowser|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(ua) || /ipad/i.test(ua) || document.body.clientWidth <= 860
    },

    initWxConfig () {
      if (!utils.isInWeixin()) return
      const url = utils.isIOS() ? this.entryUrl : window.location.href
      this.$ajax.get(`https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(url)}&mpid=geekbang`).then(response => {
        const res = response.data
        if (res.code === 0 && res.data) {
          try {
            window.wx.config({
              debug: false,
              appId: res.data.appId, // 必填，公众号的唯一标识
              timestamp: String(res.data.timestamp), // 必填，生成签名的时间戳
              nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
              signature: res.data.signature, // 必填，签名，见附录1
              jsApiList: ['getLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })
          } catch (err) {
            // console.log(err)
          }
        }
      }, response => {
        // window.alert('请求出错了')
      })
    },
    // 添加时间判断 更改 banner图
    newTime () {
      // 截止日期是截止到前一天的凌晨。例如截止日期 27号，就是26号凌晨23：59:59
      return new Date().getTime() < new Date('2022-4-27').getTime()
    }
  }
}
</script>

<style lang="scss">
@import "./style/variable";
@import './style/bulma/base/_all';
@import "./style/layout";
@import "./style/component";

@import "./assets/css/normalize.css";
@import "./assets/iconfont/iconfont.css";
@import "./assets/css/button.scss";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

body.fixed {
  position: fixed;
  top: 0 !important;
  bottom: 0;
  left: 0;
  right: 0;
}

/* 自定义滚动条样式 */
.custom-scrollbar {
  /* Firefox 滚动条宽度使用窄样式 */
  scrollbar-width: thin;

  /* 滚动条默认使用窄样式 */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: #d7d7d7;
  }
}
</style>
